<div class="no-results">
  <img alt="No result" src="assets/shared/images/error.svg">
  <h4>{{ title | translate }}</h4>
  <p>{{ description | translate }}</p>
</div>
